export default __webpack_public_path__ + "static/media/img_success_1@3x.9c18083f.png";